import React, { useState } from "react";
import "./PermissionSettings.css";

const PermissionSettings = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const permissions = [
    { module: "Student Information", feature: "Student", view: true, editDelete: true, status: true },
    { module: "Student Information", feature: "Add Student", view: true, editDelete: true, status: true },
    { module: "Student Information", feature: "Disable Student", view: true, editDelete: true, status: true },
    { module: "Student Information", feature: "Search Student", view: true, editDelete: true, status: true },
    { module: "Fees Collection", feature: "Collect Fees", view: true, editDelete: true, status: true },
    { module: "Fees Collection", feature: "Fee Type", view: true, editDelete: true, status: true },
    { module: "Fees Collection", feature: "Fee Discount", view: true, editDelete: true, status: true },
    { module: "Fees Collection", feature: "Search Fee Payment", view: true, editDelete: true, status: true },
    { module: "Fees Collection", feature: "Search Fee Dues", view: true, editDelete: true, status: true },
    { module: "Transport", feature: "Bus Track", view: true, editDelete: true, status: true },
    { module: "Transport", feature: "Address", view: true, editDelete: true, status: true },
    { module: "Transport", feature: "Track", view: true, editDelete: true, status: true },
    { module: "Transport", feature: "Route", view: true, editDelete: true, status: true },
    { module: "Google Meet", feature: "Live Classes", view: true, editDelete: true, status: true },
    { module: "Google Meet", feature: "Live Meeting", view: true, editDelete: true, status: true },
    { module: "Google Meet", feature: "Live Class Report", view: true, editDelete: true, status: true },
    { module: "Attendance", feature: "Students", view: true, editDelete: true, status: true },
    { module: "Attendance", feature: "Faculty List", view: true, editDelete: true, status: true },
    { module: "Attendance", feature: "Student List", view: true, editDelete: true, status: true },
  ];

  const filteredPermissions = permissions.filter(
    (perm) =>
      perm.module.toLowerCase().includes(searchTerm.toLowerCase()) ||
      perm.feature.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="permission-settings">
      <div className="permission-header">
        <h2>Assign Permission (Super Admin)</h2>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button>🔍</button>
        </div>
      </div>
      <table className="permission-table">
        <thead>
          <tr>
            <th>Module</th>
            <th>Feature</th>
            <th>View</th>
            <th>Edit / Delete</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredPermissions.map((perm, index) => (
            <tr key={index}>
              <td>{perm.module}</td>
              <td>{perm.feature}</td>
              <td>{perm.view ? "✔️" : "✖️"}</td>
              <td>{perm.editDelete ? "✔️" : "✖️"}</td>
              <td>
                <label className="switch">
                  <input type="checkbox" checked={perm.status} readOnly />
                  <span className="slider round"></span>
                </label>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionSettings;